import React from "react";
import { BREAKPOINT } from "../../helper/constant";
import { styles } from "./relatedProduct.style";
import useCurrentWidth from "../../hooks/widthHook";
import { serverResponse } from "../../util/fakeServer";

const RelatedProduct = ({
  sku,
  skul,
  image,
  variety,
  handleClick,
  isCarousel = false
}) => {
  const currentWidth = useCurrentWidth();
  const isMobile = currentWidth < BREAKPOINT.lg;

  return (
    <div
      style={styles.wrapper}
      className={!isMobile && !isCarousel ? "col-3 col-md-2 text-center" : ""}
    >
      <img
        onClick={() => {
          handleClick(skul);
        }}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null; // prevents looping
          currentTarget.src = `${serverResponse.config.clientIcon}`;
        }}
        id={"related_" + skul}
        src={image}
        alt="img"
        className="img-fluid mt-3 m-auto"
        style={{ cursor: "pointer", maxHeight: "180px" }}
      />
      <p
        style={styles.varieties}
        // onClick={() => props.handleClick(props.prod.item_id)}
      >
        {variety ? variety.join(" ") : ""}
      </p>
    </div>
  );
};

export default RelatedProduct;
